<template>
  <div id="mailchimpEmbed">
    <div id="mc_embed_shell">

      <div id="mc_embed_signup">
        <form action="https://gmail.us5.list-manage.com/subscribe/post?u=149ed1b8f1ebf6beeb3069328&amp;id=26c80ec2b3&amp;f_id=002f24eaf0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank">
          <div id="mc_embed_signup_scroll"><h2>Subscribe</h2>
            <div class="indicates-required mb-4"><span class="asterisk">*</span> indicates required</div>
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div>
                <div class="mc-field-group">
                  <label for="mce-FNAME" class="font-bold">First Name <span class="asterisk">*</span></label>
                  <input type="text" name="FNAME" class="required text form-element block border w-full" id="mce-FNAME" required="" value="">
                </div>
              </div>
              <div>
                <div class="mc-field-group">
                  <label for="mce-LNAME" class="font-bold">Last Name <span class="asterisk">*</span></label>
                  <input type="text" name="LNAME" class="required text form-element block border w-full" id="mce-LNAME" required="" value="">
                </div>
              </div>
              <div>
                <div class="mc-field-group">
                  <label for="mce-EMAIL" class="font-bold">Email Address <span class="asterisk">*</span></label>
                  <input type="email" name="EMAIL" class="required email form-element block border w-full" id="mce-EMAIL" required="" value="">
                </div>
              </div>
              <div>
                <div class="mc-field-group">
                  <label for="mce-ORGANIZATI" class="font-bold">State/Province </label>
                  <input type="text" name="ORGANIZATI" class=" text form-element block border w-full" id="mce-ORGANIZATI" value="">
                </div>
              </div>
            </div>
            <div id="mce-responses" class="clear">
              <div class="response" id="mce-error-response" style="display: none;"></div>
              <div class="response" id="mce-success-response" style="display: none;"></div>
            </div>
            <div aria-hidden="true" style="position: absolute; left: -5000px;">
              <input type="text" name="b_149ed1b8f1ebf6beeb3069328_26c80ec2b3" tabindex="-1" value="">
            </div>
            <div class="clear">
              <input type="submit" name="subscribe" id="mc-embedded-subscribe" class="button btn btn-primary btn-green my-4" value="Subscribe">
            </div>
          </div>
        </form>
      </div>

  </div>
  </div>
</template>
<script>

export default {
  name: "MailchimpEmbed",
  mounted() {

    // const script = document.createElement("script");
    // script.src="https://code.jquery.com/jquery-3.7.1.min.js";
    // document.body.appendChild(script);
    //

    // const script2 = document.createElement("script");
    // script2.src="https://s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js";
    // document.body.appendChild(script2);
    //
    // const linkstyle = document.createElement("link");
    // linkstyle.rel="stylesheet";
    // linkstyle.href="https://cdn-images.mailchimp.com/embedcode/classic-061523.css";
    // document.body.appendChild(linkstyle);


    let divtag = document.createElement("div");
    // divtag.setAttribute("style", "height: 500px;");

    let element = document.getElementById("mailchimpEmbed");
    element.appendChild(divtag);

    //(function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]='EMAIL';ftypes[0]='email';fnames[1]='FNAME';ftypes[1]='text';fnames[2]='LNAME';ftypes[2]='text';fnames[7]='ORGANIZATI';ftypes[7]='text';fnames[3]='ADDRESS';ftypes[3]='address';fnames[4]='PHONE';ftypes[4]='phone';fnames[5]='BIRTHDAY';ftypes[5]='birthday';fnames[6]='TITLE';ftypes[6]='text';fnames[8]='MMERGE8';ftypes[8]='text';}(jQuery));var $mcj = jQuery.noConflict(true);
  }

}

</script>